// 用户组列表
export const ALL_GROUPS = [
  {
    name: '一级审核组',
    id: 'UG_001000000022469'
  },
  {
    name: '二级审核组',
    id: 'UG_001000000021647'
  },
  {
    name: '内容修改确认组',
    id: 'UG_001000000020640'
  },
  {
    name: '管理员组',
    id: 'UG_001000000019117'
  },
  {
    name: '内容上传人组',
    id: 'UG_001000000026419'
  }
]

// 表单样式
export const FORM_ITEM_LAYOUT = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
}

// 子任务的审核状态选项
export const PROCESS_TYPES = {
  ['process_000000003973']: [
    {
      label: '不限',
      value: ''
    },
    {
      label: '一审待处理',
      value: 'first_pending'
    },
    {
      label: '一审通过',
      value: 'first_pass'
    },
    {
      label: '一审升级',
      value: 'first_upgrade'
    },
    {
      label: '一审资源处理中',
      value: 'first_process'
    },
    {
      label: '一审驳回待复审',
      value: 'first_reject_pending'
    },
    {
      label: '一审复审通过',
      value: 'first_reapprove_pass'
    },
    {
      label: '一审复审升级',
      value: 'first_reapprove_upgrade'
    },
    {
      label: '被终止',
      value: 'terminate'
    }
  ],
  ['process_000000004160']: [
    {
      label: '不限',
      value: ''
    },
    {
      label: '二审待处理',
      value: 'second_pending'
    },
    {
      label: '二审通过',
      value: 'second_pass'
    },
    {
      label: '二审资源处理中',
      value: 'second_process'
    },
    {
      label: '二审驳回待复审',
      value: 'second_reject_pending'
    },
    {
      label: '二审复审通过',
      value: 'second_reapprove_pass'
    },
    {
      label: '被终止',
      value: 'terminate'
    }
  ]
}
